import type {
  Target,
  CreateTargetDraft,
  UpsertGraphRequest,
} from "../../../generated-api";
import { client } from "../../../lib/api";

export async function upsertTargets(
  data: CreateTargetDraft,
): Promise<Target[]> {
  const results = client.targets.postTargetsGraph({
    requestBody: { targets: data } satisfies UpsertGraphRequest,
  });

  return results;
}
